import React from 'react';
import { Hero } from '../components/Hero';
import { Problem } from '../components/Problem';
import { FailedAttempts } from '../components/FailedAttempts';
import { Mechanism } from '../components/Mechanism';
import { Deliverables } from '../components/Deliverables';
import { Audience } from '../components/Audience';
import { Steps } from '../components/Steps';
import { Proof } from '../components/Proof';
import { Faq } from '../components/Faq';
import { Offer } from '../components/Offer';
import { StickyCta } from '../components/StickyCta';
import { Footer } from '../components/Footer';
export function CreditoLimpio() {
  return <div className="w-full bg-cream font-sans" data-id="element-370" data-mp="35ghwciyoqcmk">
      <Hero data-id="element-371" data-mp="30ozuztsr2a12" />
      <main data-id="element-372" data-mp="30ogg6lyec1r9">
        <Problem data-id="element-373" data-mp="30oq9ojingr1p" />
        <FailedAttempts data-id="element-374" data-mp="30o84gxe0f2hn" />
        <Mechanism data-id="element-375" data-mp="30mwzwvcqpqph" />
        <Deliverables data-id="element-376" data-mp="2czfctd4f7gsu" />
        <Audience data-id="element-377" data-mp="2cym446lwih82" />
        <Steps data-id="element-378" data-mp="2cy4a7gmpof3b" />
        <Proof data-id="element-379" data-mp="2cxkrvyt5foor" />
        <Faq data-id="element-380" data-mp="2cxb2odfxhlk4" />
        <Offer data-id="element-381" data-mp="280c67o8sl2ir" />
      </main>
      <Footer data-id="element-382" data-mp="28142706ax29k" />
      <StickyCta data-id="element-383" data-mp="27zj8fcrt9ncr" />
    </div>;
}